export const productName = 'DRILLING & WELL ENGINEERING TEACHER READY';
export const productShortName = 'Drilling & Well Engineering Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/3oAxQTLSuuzocdXtATtFMG/MOCKUP.png';

export const checkoutUrl = 'https://drilling-well-engineering-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Drilling & Well Engineering Fundamentals',
  'Volume 2 — Well Planning, Geology & Drilling Operations',
  'Volume 3 — Drilling Rigs, Equipment & Systems',
  'Volume 4 — Drilling Fluids & Well Circulation',
  'Volume 5 — Casing, Cementing & Well Construction',
  'Volume 6 — Well Completion & Production Fundamentals',
  'Volume 7 — Well Control, Pressure Management & Operational Safety',
  'Volume 8 — Drilling Performance, Troubleshooting & Well Problems',
  'Volume 9 — Teaching Drilling & Well Engineering',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Drilling & Well Engineering Teacher Assessment Kit',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Drilling & Well Engineering Teacher Dictionary: 200 Essential Concepts',
  'Bonus 5 — Drilling & Well Engineering Teacher Lesson Planning Guide (30 Lesson Structures)',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex drilling and well engineering concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see drilling's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
